import { type Notification as NotificationResponse } from '@shared/api';

import type { Notification } from '../model/notification';

/** 응답 → 뷰모델. 계약의 중첩 `portfolio`(id · name)를 화면이 쓰는 평면 필드로 */
export function toNotification(item: NotificationResponse): Notification {
  return {
    id: item.id,
    portfolioId: item.portfolio.id,
    portfolioName: item.portfolio.name,
    notifiedAt: item.notifiedAt,
    type: item.type,
    content: item.content,
    isRead: item.isRead,
  };
}
